import gql from 'graphql-tag'

const DebtScheduleQuery = gql`
  query DebtScheduleQuery($rid: Int!) {
    business(rid: $rid) {
      rid
      loanTypeOptions
      noExistingDebt
      outstandingLoans {
        rid
        active
        refinance
        lender
        creLoan
        debtType
        monthsRemaining
        principalBalance
        originationDate
        maturityDate
        monthlyPayment
        minimumPayment
        paymentFrequency
      }
    }
  }
`

export default DebtScheduleQuery
